import React, { useContext } from 'react';
import styled from 'styled-components';
import { useTheme, Typography, Icon } from '@material-ui/core';
import { PaneContext } from '../../../contexts/PaneContext';
import AddIcon from '@material-ui/icons/Add';
import PersonIcon from '@material-ui/icons/Person';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import SettingsIcon from '@material-ui/icons/Settings';

const Pane = ({ children, colour, variant, subHeader, ...props }) => {
  const { newPatronMode } = useContext(PaneContext);
  const { palette } = useTheme();

  const showSubHeader =
    variant === 'admin' ||
    variant === 'import' ||
    variant === 'settings' ||
    variant === 'reports' ||
    (newPatronMode && variant === 'new');

  return (
    <Container {...props}>
      {/* Toggle for 'Add new' window */}
      {showSubHeader && (
        <SubHeader background={palette.background.default} colour={colour}>
          <Icon
            icon={
              variant === 'admin' ? (
                <PersonIcon />
              ) : variant === 'import' ? (
                <ImportContactsIcon />
              ) : variant === 'settings' ? (
                <SettingsIcon />
              ) : (
                <AddIcon />
              )
            }
          />
          {subHeader}
        </SubHeader>
      )}
      <PaneContainer
        variant={variant}
        newPatronMode={newPatronMode}
        subHeader={subHeader}
        colour={colour}
      >
        {children}
      </PaneContainer>
    </Container>
  );
};

const Container = styled.section`
  position: relative;
  display: flex;
  flex: 1;
`;

const PaneContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  border-radius: ${(props) =>
    (props.subHeader && props.variant !== 'new') ||
    (props.newPatronMode && props.variant === 'new')
      ? '0 1.4rem 1.4rem 1.4rem'
      : '1.4rem'};
  border: 2px solid ${(props) => props.colour};
  color: ${(props) => props.colour};
  overflow: auto;
`;

const SubHeader = styled(Typography)`
  color: ${(props) => props.colour};
  font-weight: 700;
  font-style: italic;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  top: -32px;
  left: 0;
  border: 2px solid;
  border-bottom: none;
  border-radius: 1rem 1rem 0 0;
  background: ${(props) => props.background};
  padding: 0.5rem 1rem 3px 1rem;
`;

export default Pane;
